import { render, staticRenderFns } from "./idol.vue?vue&type=template&id=d3f56b2e&scoped=true"
import script from "./idol.vue?vue&type=script&lang=js"
export * from "./idol.vue?vue&type=script&lang=js"
import style0 from "./idol.vue?vue&type=style&index=0&id=d3f56b2e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f56b2e",
  null
  
)

export default component.exports